import React from 'react'
import OneColWrapper from '../technical/OneColWrapper'
import Richtext from '../atoms/Richtext'

const InterviewBlock = ({ block }) => {
  return (
    <OneColWrapper block={block} className="interview-block">
      <div className="interview-block-interview">
        {block.interview_sections.map((item, index) => (
          <>
            {item.question?.length > 0 && (
              <span className="interview-block-interview-question">
                {item.question}
              </span>
            )}
            {item.answer?.length > 0 && (
              <Richtext
                className="interview-block-interview-answer"
                text={item.answer}
              />
            )}
          </>
        ))}
      </div>
    </OneColWrapper>
  )
}

export default InterviewBlock
